export default __webpack_public_path__ + "img/yester_icon_blue_green.png";